import React from 'react';

const PermissionErrorPage = () => {
  return (
    <div style={{ textAlign: 'center', padding: '50px' }}>
      <h1>You do not have permission to access this page</h1>
      <p>If you believe this is an error, please contact support.</p>
    </div>
  );
};

export default PermissionErrorPage;
